module.exports = __webpack_public_path__ + "img/1511423484.f9cd2afb.jpg";